import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuestionnaireResultsReport } from "@/hooks/reports/questionnaire-results-report.hook";
import { cn } from "@/lib/utils";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { FC, HTMLAttributes } from "react";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const NUMBER_OF_YEARS = 4;

type AnnualPerformanceCardProps = HTMLAttributes<HTMLDivElement>;

const AnnualPerformanceCard: FC<AnnualPerformanceCardProps> = ({
  className,
  ...props
}) => {
  const { data: userProfile } = useCurrentUserProfile();

  const { data: results, isLoading: isResultsLoading } =
    useQuestionnaireResultsReport({
      companyId: userProfile?.companyId || "",
      years: Array.from(
        { length: NUMBER_OF_YEARS },
        (_, index) => new Date().getFullYear() - index,
      ),
    });

  const chartDataArray = {
    labels: results?.content.map((item) => item.edition.year) || [],
    data: results?.content.map((item) => item.result.score) || [],
  };

  const chartData = {
    labels: chartDataArray.labels,
    datasets: [
      {
        label: "Resultado",
        data: chartDataArray.data,
        backgroundColor: "#615CB7",
        barThickness: 40,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        ticks: {
          stepSize: 20,
        },
        min: 0,
        max: 100,
      },
    },
  };

  return (
    <Card className={cn(className, "rounded-xl px-5 py-3")} {...props}>
      <p className="mb-1 mt-2 text-xl font-bold text-[#13171B]">
        Desempeño anual
      </p>

      <p className="mb-5 text-sm font-light text-[#8090A3]">
        En este gráfico podrás observar tu puntaje de desempeño durante las{" "}
        {NUMBER_OF_YEARS} últimas ediciones.
      </p>

      {isResultsLoading && (
        <Skeleton style={{ width: "100%", height: "200px" }} />
      )}

      {results && <Bar data={chartData} options={chartOptions} />}
    </Card>
  );
};

export default AnnualPerformanceCard;
